// Suche in der Kundenliste (customerpublic) für Anmeldung und Mandantenwechsel (Kundenwünsche 13.10.2026: „die
// kundenauswahl … dass man das nicht sofort alles sieht und nicht dieses ewig lange dropdown hat“, „auch beim
// mandantenwechsel bitte mit suchfeld“): Treffer erst ab zwei Zeichen oder einer Ziffer, höchstens acht; ohne Groß- und
// Kleinschreibung und Akzente, mehrere Wörter in beliebiger Reihenfolge über „Nummer Name“. Reihenfolge: genaue Nummer,
// Nummer am Anfang, Name am Anfang, übrige Treffer; innerhalb davon nach Kundennummer (wie die frühere Liste,
// Kundenwunsch 12.10.2026).
import { foldText } from '@/components/sales/saleFilters';

export const CUSTOMER_SEARCH_MAX = 8;

// „60 Edzards Reisen“
export function customerLabel(customer) {
  return customer ? `${customer.customer_id} ${customer.name || ''}`.trim() : '';
}

// genug eingegeben, um zu suchen?
export function customerQueryReady(query) {
  const q = foldText(String(query || '').trim());
  return q.length >= 2 || /^\d+$/.test(q);
}

export function searchCustomers(customers, query, max = CUSTOMER_SEARCH_MAX) {
  if (!customerQueryReady(query)) {
    return [];
  }
  const q = foldText(String(query).trim());
  const tokens = q.split(/\s+/).filter(Boolean);
  const rank = (c) => {
    const id = String(c.customer_id);
    if (id === q) return 0;
    if (id.indexOf(q) === 0) return 1;
    if (foldText(c.name || '').indexOf(q) === 0) return 2;
    return 3;
  };
  return (customers || [])
    .filter((c) => {
      const hay = foldText(customerLabel(c));
      return tokens.every((t) => hay.indexOf(t) !== -1);
    })
    .map((c) => ({ c, r: rank(c) }))
    .sort((a, b) => a.r - b.r || Number(a.c.customer_id) - Number(b.c.customer_id))
    .slice(0, max)
    .map((x) => x.c);
}

// genauer Treffer (ganze Nummer, ganzer Name oder „Nummer Name“), sonst null
export function exactCustomer(customers, query) {
  const q = foldText(String(query || '').trim());
  if (!q) {
    return null;
  }
  return (customers || []).find((c) => (
    String(c.customer_id) === q || foldText(c.name || '') === q || foldText(customerLabel(c)) === q
  )) || null;
}
